import type { ReactNode } from 'react';

type AlertVariant = 'error' | 'warning' | 'success' | 'info';

interface AlertProps {
  variant?: AlertVariant;
  children: ReactNode;
  className?: string;
}

// Use explicit Tailwind palette colors (not @theme variables) so that the
// opacity modifier utilities (`/10`, `/30`) resolve reliably on dark
// surfaces. In Tailwind v4, `bg-success/10` on a single-shade `--color-success`
// token was collapsing to near-black in some builds — see Sprint 10.5G #1a.
const variantClasses: Record<AlertVariant, string> = {
  error: 'bg-red-500/10 border-red-500/30 text-red-300',
  warning: 'bg-yellow-500/10 border-yellow-500/30 text-yellow-300',
  success: 'bg-emerald-500/10 border-emerald-500/30 text-emerald-300',
  info: 'bg-helm-500/10 border-helm-500/30 text-helm-400',
};

export function Alert({ variant = 'error', children, className = '' }: AlertProps) {
  return (
    <div className={`border text-sm rounded-lg px-4 py-3 mb-4 ${variantClasses[variant]} ${className}`}>
      {children}
    </div>
  );
}
